import { render, staticRenderFns } from "./existenceEmergencyProcurement.vue?vue&type=template&id=82b3eab8"
import script from "./existenceEmergencyProcurement.vue?vue&type=script&lang=js"
export * from "./existenceEmergencyProcurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports